<template>
  <v-card
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card-title>{{ faq.default_translation.name }}</v-card-title>
    <v-card-subtitle :class="{'pb-0': $vuetify.breakpoint.mdAndUp}">
      {{ faq.default_translation.description || '-' }}
    </v-card-subtitle>
    <v-card-actions>
      <v-list-item class="grow">
        <v-row
          align="center"
          justify="end"
        >
          <v-tooltip
            v-for="(item, idx) in meta"
            :key="idx"
            bottom
          >
            <template #activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="justify-center d-flex align-center"
                v-on="on"
              >
                <v-icon
                  class="mr-1"
                  v-text="item.icon"
                />
                <small class="mr-3">{{ item.label }}</small>
              </div>
            </template>
            <span>{{ item.tooltip }}</span>
          </v-tooltip>
        </v-row>
      </v-list-item>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    faq: {
      type: Object,
      required: true
    },
  },

  computed: {
    meta() {
      const faq = this.faq;
      const lang = faq.all_languages[faq.default_language].name;
      const languages = faq.additional_languages;
      return [
        {
          show: true,
          icon: 'mdi-earth',
          label: languages.length > 0 ? `${lang} (+${languages.length})` : lang,
          tooltip: `${this.$t('Additional languages')}: ${languages.length > 0 ? `${languages.map(lang => lang.code).join(', ')}` : `-`}`
        },
        {
          show: this.$vuetify.breakpoint.mdAndUp,
          icon: 'mdi-clock-outline',
          label: faq.last_activity || this.$t('No activity'),
          tooltip: this.$t('When the last activity from a user was recorded')
        },
        {
          show: this.$vuetify.breakpoint.mdAndUp,
          icon: 'mdi-calendar-edit',
          label: faq.updated_at,
          tooltip: this.$t('When this FAQ was last updated')
        },
        {
          show: true,
          icon: 'mdi-comment-question-outline',
          label: faq.num_questions,
          tooltip: this.$t('The number of questions')
        },
        {
          show: true,
          icon: 'mdi-label-multiple-outline',
          label: faq.num_categories + faq.num_subcategories,
          tooltip: this.$t('The number of categories')
        },
      ].filter(obj => obj.show);
    }
  }
}
</script>